import OfficeOverheadItem from '../Domain/OfficeOverheadItem';
import OfficeOverheadQuarterItem from '../Domain/OfficeOverheadQuarterItem';
import AuthService from './authService';

class OfficeOverheadService 
{

	static GetOfficeOverheadList(CountryId) 
	{
		let url = `/api/OfficeOverhead/GetOfficeOverheadList/${CountryId}`;
		return AuthService.getInstance().CallBackendFunction(url);
	}

	static RemoveOfficeOverhead(CountryId) 
	{
		let url = `/api/OfficeOverhead/RemoveOfficeOverhead/${CountryId}`;
		return AuthService.getInstance().CallBackendFunctionDelete(url);
	}

	static async EditOfficeOverhead(editOffice) 
	{
		let url = "/api/OfficeOverhead/EditAsync/";
		let officeOverhead = OfficeOverheadService.CreateEditedOfficeOverheadObject(editOffice)

		return AuthService.getInstance().CallBackendFunctionPut(url, officeOverhead)
	}

	static CreateEditedOfficeOverheadObject(editOfficeOverhead)
    {
        let eooJson= {
			Quarter:editOfficeOverhead.Quarter.toString(),
            OfficeOverheadId : editOfficeOverhead.OfficeOverheadId.toString(),
            OfficeId : editOfficeOverhead.OfficeId.toString(),
            PricingOverheadRate : editOfficeOverhead.PricingOverheadRate.toString(),
            ActualOverheadRate : editOfficeOverhead.ActualOverheadRate.toString(),
		};
		return JSON.stringify(eooJson);
    }

	static async GetOfficeOverhead(officeOverhead) 
	{
		let url = "/api/OfficeOverhead/GetOfficeOverheadListOfCountry?OfficeIds=" + JSON.stringify(officeOverhead);
		return AuthService.getInstance().CallBackendFunction(url);
	}

	static async CreateOfficeOverhead(createOfficeOverhead) 
	{
		var officeOverheadData = OfficeOverheadQuarterItem.CreateEditedOfficeOverheadItemObject(createOfficeOverhead);

		let url = "api/OfficeOverhead/PostListOfOverheadAsync/";
		var authService = AuthService.getInstance();
		return authService.CallBackendFunctionPost(url, officeOverheadData);
	}

	static GetQuarterListName(items) 
	{
		var convertedItems = [];
		if (items !== null) {
			items.forEach((item) => {
				convertedItems.push(
					{
						label: item.Quarter,
						value: item.Quarter,
					}
				);
			});
		}
		return convertedItems;
	}

	static ConvertAvailableQuarterList(items) 
	{
		var convertedItems = [];
		if (items !== null) {
			items.forEach((item) => {
				var newItem = new OfficeOverheadQuarterItem(item);
				convertedItems.push(newItem);
			});
		}
		return convertedItems;
	}

	static ConvertDBOfficeOverhead(items) 
	{
		var convertedItems = [];
		if (items !== null) {
			items.forEach((item) => {
				var newItem = new OfficeOverheadItem(item);
				convertedItems.push(newItem);
			});
		}

		return convertedItems;
	}
}
export default OfficeOverheadService;